/**
 * Reference images for inventory item cards. Illustrative catalog-style images (not customer belongings),
 * used so customers recognize each item quickly. Keyed by inventory item id in data/inventory.ts.
 */
const GEN = 'https://cdn.magicpatterns.com/patterns/generated-images';

export const itemImages: Record<string, string> = {
  bed_king: `${GEN}/3b868a0f-a064-4da7-b8b3-e3500775d4a6.jpg`,
  bed_queen: `${GEN}/59eb6bce-7d34-4f1b-852f-9bb44e73e1df.jpg`,
  bed_full: `${GEN}/57b7d063-e96c-44d3-b7a5-91aff9a538bd.jpg`,
  bed_twin: `${GEN}/145bea4d-a955-43cd-a39e-94bcd62a545d.jpg`,
  mattress: `${GEN}/dc6ddf19-09a2-4928-9817-7da41c605187.jpg`,
  dresser: `${GEN}/74e458f0-fae9-4df2-8d01-f58960abe9ea.jpg`,
  nightstand: `${GEN}/bae5178a-503e-4d1d-a6a9-5784825a1f1e.jpg`,
  wardrobe: `${GEN}/04d39e6c-25e7-4c58-a5f3-5968cbd21870.jpg`,
  sofa: `${GEN}/d99324d1-4e7b-4554-b250-b46eba76bf11.jpg`,
  sectional: `${GEN}/a51f4bd3-0fee-4d55-adda-17901f78b1ee.jpg`,
  armchair: `${GEN}/afc89c16-5042-49d9-8a42-b85c17c2a765.jpg`,
  coffee_table: `${GEN}/00da61eb-e34a-4f1e-8740-5109a194b1f7.jpg`,
  tv: `${GEN}/653945a4-b65e-45ba-a63d-680767bcc3ae.jpg`,
  tv_stand: `${GEN}/9cd8379c-e820-45f7-a782-47150d16aaad.jpg`,
  bookcase: `${GEN}/722ae8cf-6b7d-4ac2-8c72-19b795b6852a.jpg`,
  dining_table: `${GEN}/86493206-99f2-4a1b-961c-88f46fd50500.jpg`,
  dining_chair: `${GEN}/8cce1050-0205-4a56-bda6-2a48a6cb0d3a.jpg`,
  fridge: `${GEN}/98145ac4-663d-411e-8ff9-c66fbbef6685.jpg`,
  washer: `${GEN}/3b0fb4a0-73dc-49ee-9058-c890e6f9a34d.jpg`,
  dryer: `${GEN}/77ef3a34-4c61-44e9-9dd6-bd2cd268eff7.jpg`,
  desk: `${GEN}/405a5c5d-53ef-4f2d-b312-e636b2f73ef2.jpg`,
  office_chair: `${GEN}/0524e263-8128-4124-8299-9ce4e3a1b7b9.jpg`,
  file_cabinet: `${GEN}/2116ec03-637d-40f4-9b3f-fae288813ce9.jpg`,
  box_small: `${GEN}/405ac82d-d037-4e2d-8c14-60329b47e574.jpg`,
  box_medium: `${GEN}/d2b89366-c59c-4e5f-adde-e2ab48126914.jpg`,
  box_large: `${GEN}/3b2e148a-bb96-432f-8945-a64c1270a8b2.jpg`,
  box_wardrobe: `${GEN}/25f9db6c-6c97-422c-97be-dcca7b5e4950.jpg`,
  patio_set: `${GEN}/f1a6da83-c086-47a9-8eff-c7aec47360dc.jpg`,
  grill: `${GEN}/279bfadc-4322-42af-bc5a-0b1bd5bdf4c3.jpg`,
  bike: `${GEN}/eade64e9-6616-4d35-a3ac-ccdf32289c24.jpg`,
  tool_chest: `${GEN}/2abd1999-7956-476f-a66e-b716e54deb1e.jpg`,
  bed_cal_king: `${GEN}/3b868a0f-a064-4da7-b8b3-e3500775d4a6.jpg`,
  bunk_bed: `${GEN}/e3a66155-8a2d-454b-9100-477f299b5b93.jpg`,
  loveseat: `${GEN}/8fb364f6-50e0-435b-a71d-da7907f863cb.jpg`,
  side_table: `${GEN}/59c16d2e-b831-4acf-9595-0c29d4eccb17.jpg`,
  mirror: `${GEN}/f38b6e86-6fa9-4d41-860f-6b59fd3d15f2.jpg`,
  bar_stool: `${GEN}/691eafdc-1832-4df9-8c80-d44a9351d1f6.jpg`,
  china_cabinet: `${GEN}/991520a8-a0ce-498c-bc6c-e568d5a3f36f.jpg`,
  monitor: `${GEN}/251e7744-7675-4ee5-b796-149f1d5e755b.jpg`,
  shelving: `${GEN}/396dcceb-df53-46f6-8533-2ec99a0ecf28.jpg`,
  storage_bin: `${GEN}/02bd868a-fbff-4955-8345-f0a32752604c.jpg`,
};

/** Image for any inventory key (`item` or `item:variant`). */
export function imageForKey(key: string): string | undefined {
  return itemImages[key.split(':')[0]];
}
